<template>
    <div>
        
        <button @click="toggle" class="mb-0 block mg-button mg-button--larger text-center w-full">
            <span class="w-full flex items-center justify-center block">
                <span class="block" v-html="buttonIcon"></span>
                <span class="block">{{buttonVerb}} Worldwide Data</span>
                <span class="block" v-html="buttonIcon"></span>
            </span>
        </button>

        <transition 
            enter-active-class="animated fadeIn" 
			leave-active-class="animated fadeOut">
            <div v-if="enabled" class="flex xl:hidden items-center text-xs md:text-sm my-8 no-print">
                <div>Hide Dollar Values</div>
                <div class='mg-toggle mx-4'>
                    <input id='dollarToggle2' type='checkbox' v-model="dollarsOption">
                    <label for='dollarToggle2'>
                        <span class="invisible">Show dollar values?</span>
                    </label>
                </div>
                <div>Show Dollar Values</div>
            </div>
        </transition>

        <transition 
            enter-active-class="animated fadeIn" 
			leave-active-class="animated fadeOut">
            <div class="table-market-data-worldwide-wrap overflow-x-scroll -mt-2">
                <table v-if="enabled" class="mb-0 text-sm heading-font striped border-separate border-b table-market-data-worldwide">
                    <thead>
                        <tr class="uppercase antialiased text-sm text-white tracking-medium border-b-0">
                            <th class="border-b-0 border-r mg-border-screen-lightest font-normal w-36 px-0 pt-4 pb-1 text-right mg-banded-accent-2" scope="col"><span class="px-6 block">U.S. Export PARTNERS IN ({{units}})</span></th>
                            
                            <th class="border-b-0 border-r mg-border-screen-lightest font-normal px-6 pt-4 pb-1 text-center mg-banded-accent-2" scope="col">{{marketYear - 6}}/{{marketYear - 5}}</th>
                            <th class="border-b-0 border-r mg-border-screen-lightest font-normal px-6 pt-4 pb-1 text-center mg-banded-accent-2" scope="col">{{marketYear - 5}}/{{marketYear - 4}}</th>
                            <th class="border-b-0 border-r mg-border-screen-lightest font-normal px-6 pt-4 pb-1 text-center mg-banded-accent-2" scope="col">{{marketYear - 4}}/{{marketYear - 3}}</th>
                            <th class="border-b-0 border-r mg-border-screen-lightest font-normal px-6 pt-4 pb-1 text-center mg-banded-accent-2" scope="col">{{marketYear - 3}}/{{marketYear - 2}}</th>
                            <th class="border-b-0 border-r mg-border-screen-lightest font-normal px-6 pt-4 pb-1 text-center mg-banded-accent-2" scope="col">{{marketYear - 2}}/{{marketYear - 1}}</th>
                            
                            <th class="border-b-0 font-normal px-4 pt-4 pb-2 w-36 mg-banded-primary-darker" scope="col">Previous Market Year ({{marketDataSettings.previous_market_year_label}})</th>
                            <th class="border-b-0 font-normal p-0 w-36 mg-banded-primary" scope="col"><span class="px-4 pt-4 pb-2 block">Current Market Year ({{marketDataSettings.current_market_year_label}})</span></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(market, index) in market_data" :key="index" v-if="market[top_exports_selected] && market[top_exports_selected]['current_market_year_quantity'] != null" class="border-0 tracking-medium text-base">
                            <th scope="row" class="mg-banded-secondary-lighter text-white heading-font uppercase text-right font-normal mg-border-secondary border-b antialiased"><span class="px-2">{{market['market_name']}}</span></th>
                            <td v-for="i in 5" :key="i" class="py-2 px-4">
                                <div>{{formatNumber(market[top_exports_selected][`year_${i}_quantity`])}}</div>
                                <div v-if="showDollars">${{formatNumber(market[top_exports_selected][`year_${i}_value`])}}</div>
                            </td>
                            <td class="py-2 px-4 border-l-8 border-r-8 mg-border-primary-darker align-bottom">
                                <div>
                                    {{formatNumber(market[top_exports_selected]['previous_market_year_quantity'])}}
                                </div>
                                <div v-if="showDollars">
                                    ${{formatNumber(market[top_exports_selected]['previous_market_year_value'])}}
                                </div>
                            </td>
                            <td class="py-2 px-4 border-l-8 border-r-8 mg-border-primary">
                                <div class="pr-8 relative">
                                    <div class="absolute pin-t pin-r -mt-1 mr-1 text-xs" :class="{'success-color': market[top_exports_selected]['change'] > 0, 'error-color': market[top_exports_selected]['change'] <= 0}">
                                        <svg v-if="getPercent(market[top_exports_selected]['change']) != 'N/A'" class="mg-icon">
                                            <use :href="getArrowName(market[top_exports_selected]['change'])" :xlink:href="getArrowName(market[top_exports_selected]['change'])" />
                                        </svg> {{getPercent(market[top_exports_selected]['change'])}}
                                    </div>

                                    {{formatNumber(market[top_exports_selected]['current_market_year_quantity'])}}
                                </div>
                                <div v-if="showDollars">
                                    ${{formatNumber(market[top_exports_selected]['current_market_year_value'])}}
                                </div>
                            </td>
                        </tr>
                        <tr v-if="export_totals" class="border-0 tracking-medium text-base">
                            <th scope="row" class="mg-banded-secondary text-white heading-font uppercase text-right font-medium antialiased"><span class="px-2">World Total</span></th>
                            
                            <td v-for="i in 5" :key="i" class="py-2 px-4">
                                <div>{{formatNumber(export_totals[top_exports_selected][`year_${i}_quantity`])}}</div>
                                <div v-if="showDollars">${{formatNumber(export_totals[top_exports_selected][`year_${i}_value`])}}</div>
                            </td>
                            
                            <td class="py-2 px-4 border-l-8 border-r-8 border-b-8 mg-border-primary-darker">
                                <div>
                                    {{formatNumber(export_totals[top_exports_selected]['previous_market_year_quantity'])}}
                                </div>
                                <div v-if="showDollars">
                                    ${{formatNumber(export_totals[top_exports_selected]['previous_market_year_value'])}}
                                </div>
                            </td>
                            <td class="py-2 px-4 border-l-8 border-r-8 border-b-8 mg-border-primary">
                                <div>
                                    {{formatNumber(export_totals[top_exports_selected]['current_market_year_quantity'])}}
                                </div>
                                <div v-if="showDollars">
                                    ${{formatNumber(export_totals[top_exports_selected]['current_market_year_value'])}}
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
		</transition>
    </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from "vuex";
import numeral from "numeral";

import formatNumber from "../utilities/format-number";
import getArrowName from "../utilities/get-svg-arrow-name";
import getPercent from "../utilities/get-percent";

export default {
    name: "market-data-worldwide",
    data() {
        return {
            enabled: false
        };
    },
    computed: {
        ...mapState([
            "showDollars",
            "market_data",
            "top_exports_selected",
            "export_totals",
            "marketDataSettings"
        ]),
        dollarsOption: {
            get() {
                return this.showDollars;
            },
            set(value) {
                this.updateDollarsOption(value);
            }
        },
        units() {
            return this.top_exports_selected == "ethanol-(non-bev.)"
                ? "GAL"
                : "MT";
        },
        buttonVerb() {
            return this.enabled ? "Hide" : "Show";
        },
        buttonIcon() {
            const iconName = this.enabled
                ? "#icon-angle-up"
                : "#icon-angle-down";
            return `<span class="flex mx-4 mg-icon--medium round mg-banded-screen-lightest text-center items-center justify-center">
                <svg class="mg-icon mg-icon--medium">
                    <use href="${iconName}" xlink:href="${iconName}" />
                </svg>
            </span>`;
        },
        marketYear() {
            return this.marketDataSettings.current_market_year;
        }
    },
    methods: {
        ...mapMutations(["updateDollarsOption"]),
        formatNumber: formatNumber,
        getArrowName: getArrowName,
        getPercent: getPercent,
        toggle() {
            this.enabled = !this.enabled;
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/js/vue-components/market-data-worldwide.vue